import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
const Page = ({ pageContext, data }) => {

    return (
        <>
            <DraftDebug publishedAt={data?.datoCmsPage?.meta?.publishedAt} />
            <HelmetDatoCms seo={data?.datoCmsPage?.seoMetaTags}>
                <body className={`page-template page-template--${data?.datoCmsPage?.slug === 'index' ? 'home' : data?.datoCmsPage?.slug}`} />
            </HelmetDatoCms>
            <BlockRenderer data={data?.datoCmsPage?.blocks} />
        </>
    )
}

export const query = graphql`
    query PageTemplate ($originalId: String!) {
        datoCmsPage(originalId: { eq: $originalId }) {
            seoMetaTags {
                tags
            }
            jsonLd
            slug
            meta {
                publishedAt
            }
            blocks {
                __typename
                ...FormSelectorProps
                ...LandingBannerProps
                ...KeyCalloutProps
                ...LatestListingProps
                ...BannerProps
                ...CtaProps
                ...DownloadCtaProps
                ...TestimonialProps
                ...PropertyArchiveProps
                ...ProjectArchiveProps
                ...UpcomingArchiveProps
                ...BasicPageProps
                ...TeamArchiveProps
                ...ContactProps
                ...ThankYouProps
                ...PageHeaderIndexProps
                ...ColumnCardProps
                ...TitleColumnContentProps
                ...PageHeaderProps
            }
        }
    }
`
export default Page
